// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-divider {
  display: inline-block;
  vertical-align: top;
  border-left: 1px solid rgb(92%, 92%, 92%);
  margin-left: 8px;
  margin-right: 8px;
  height: 21px;
}

/* .individual-view {
	height: calc(100vh - 46px - 27px - 80px);
	//margin-right: -17px;
}
 */
a.list-row,
a.list-row * {
  text-decoration: none;
  cursor: pointer;
}

.list-view, .list-view-group {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px;
}
.list-view.with-padding-right .list-row, .with-padding-right.list-view-group .list-row {
  padding: 10px;
}
.list-view .list-row, .list-view-group .list-row {
  display: block;
  padding: 5px;
  background: #fff;
  color: #666;
}
.list-view .list-row.active, .list-view-group .list-row.active, .list-view .list-row:hover, .list-view-group .list-row:hover {
  background: #eee;
}
.list-view .list-row .pull-right, .list-view-group .list-row .pull-right {
  text-align: right;
}
.list-view a, .list-view-group a {
  color: inherit;
}
.list-view .action-item, .list-view-group .action-item {
  font-size: 17px;
  padding-left: 2px;
  padding-right: 2px;
  line-height: 24px;
}
.list-view .action-item .material-icons, .list-view-group .action-item .material-icons,
.list-view .action-item i,
.list-view-group .action-item i {
  color: inherit;
  vertical-align: middle;
}
.list-view .action-item.online, .list-view-group .action-item.online {
  color: #28a745;
}
.list-view .action-item.unknown, .list-view-group .action-item.unknown {
  color: #ffc107;
}
.list-view .action-item.stop, .list-view-group .action-item.stop {
  color: #dc3545;
}
.list-view .action-item.offline, .list-view-group .action-item.offline {
  color: #999;
}
.list-view .action-item.away, .list-view-group .action-item.away {
  color: #ffc107;
}
.list-view .action-item .circle, .list-view-group .action-item .circle {
  margin-top: -0.2em;
}
.list-view .action-item .sub-menu, .list-view-group .action-item .sub-menu {
  min-width: 200px;
}
.list-view .action-item.hovered:hover, .list-view-group .action-item.hovered:hover {
  color: #00c179;
}
.list-view .action-view:hover, .list-view-group .action-view:hover {
  color: #00c179;
}
.list-view .action-clear-list, .list-view-group .action-clear-list {
  color: #dc3545;
}
.list-view .action-clear-list a, .list-view-group .action-clear-list a {
  cursor: pointer;
}
.list-view, .list-view-group {
  /* .action-ellipsis {
  	visibility: hidden;
  } */
}

.list-view-group .list-row {
  background: #f9f9f9;
}

.group-view .list-view .list-row, .group-view .list-view-group .list-row {
  padding-left: 28px;
}
.group-view .list-view-group .list-row {
  padding-left: 5px;
}
.group-view .list-view-group .list-row .unit-name {
  font-weight: 600;
  max-width: 120px;
  min-width: 120px;
}

.action-view svg {
  max-width: 18px;
}

.action-running svg {
  max-width: 13px;
}

.action-accuracy svg {
  max-width: 16px;
}

.action-connection svg {
  max-width: 16px;
}

.action-battery svg {
  max-width: 21;
}

.action-additional-menu svg {
  max-width: 14px;
}

.action-clear-list svg {
  max-width: 11px;
}

.action-ellipsis svg {
  max-width: 6px;
}

.unit-name {
  max-width: 155px;
  min-width: 155px;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  text-overflow: ellipsis;
  line-height: 18px;
  margin-left: 10px;
  vertical-align: middle;
}
.unit-name img {
  max-width: 20px;
  height: auto;
  vertical-align: middle;
  margin-right: 5px;
}
.unit-name.unit-name-full {
  min-width: inherit;
  max-width: none;
}

.checkbox.full {
  display: block;
  width: auto;
}
.checkbox.full .unit-name {
  display: block;
  min-width: inherit !important;
  max-width: none !important;
}

.unit-details-box {
  background: #fff;
  padding: 10px;
  border-bottom: 1px solid rgb(90%, 90%, 90%);
}
.unit-details-box .time-address-row {
  margin-top: 0;
  line-height: 1.7;
}
.unit-details-box .statistics-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  margin-bottom: 10px;
}
.unit-details-box .statistics-table td {
  text-align: center;
  border: 1px solid rgb(90%, 90%, 90%);
  vertical-align: middle;
  padding: 10px;
}
.unit-details-box .caption-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 10px;
}
.unit-details-box .caption-table td {
  border: 1px solid rgb(90%, 90%, 90%);
  vertical-align: middle;
  padding: 5px 10px;
}
.unit-details-box .caption-table th {
  border: 1px solid rgb(90%, 90%, 90%);
  background: #fff;
  font-weight: normal;
  padding: 5px 10px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Users/index.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAGA;EACE,qBAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAFF;;AAKA;;;;EAAA;AAMA;;EAEE,qBAAA;EACA,eAAA;AAHF;;AAKA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,eC4Ca;AD9Cf;AAGE;EACE,aAAA;AADJ;AAGE;EACE,cAAA;EACA,YAAA;EAEA,gBC2BW;ED1BX,WCKO;ADPX;AAGI;EAEE,gBCwBc;AD1BpB;AAII;EACE,iBAAA;AAFN;AAKE;EACE,cAAA;AAHJ;AAKE;EACE,eCuBe;EDtBf,iBAAA;EACA,kBAAA;EACA,iBAAA;AAHJ;AAII;;;EAEE,cAAA;EACA,sBAAA;AADN;AAGI;EACE,cCfO;ADcb;AAGI;EACE,cCfQ;ADcd;AAGI;EACE,cCpBK;ADmBX;AAGI;EACE,WCnBM;ADkBZ;AAGI;EACE,cCxBQ;ADuBd;AAGI;EACE,kBAAA;AADN;AAGI;EACE,gBAAA;AADN;AAGI;EACE,cC9EO;AD6Eb;AAIE;EACE,cClFS;ADgFb;AAKE;EACE,cC3CO;ADwCX;AAII;EACE,eAAA;AAFN;AAjEA;EAuEE;;KAAA;AADF;;AAQE;EACE,mBCzCY;ADoChB;;AAUE;EACE,kBAAA;AAPJ;AASE;EACE,iBAAA;AAPJ;AAQI;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AANN;;AAWA;EACE,eAAA;AARF;;AAUA;EACE,eAAA;AAPF;;AASA;EACE,eAAA;AANF;;AAQA;EACE,eAAA;AALF;;AAOA;EACE,aAAA;AAJF;;AAMA;EACE,eAAA;AAHF;;AAKA;EACE,eAAA;AAFF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;AADF;AAEE;EACE,eAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;AAAJ;AAEE;EACE,kBAAA;EACA,eAAA;AAAJ;;AAIA;EACE,cAAA;EACA,WAAA;AADF;AAEE;EACE,cAAA;EACA,6BAAA;EACA,0BAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,aAAA;EACA,2CAAA;AADF;AAEE;EACE,aAAA;EACA,gBAAA;AAAJ;AAEE;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AAAJ;AACI;EACE,kBAAA;EACA,oCAAA;EACA,sBAAA;EACA,aAAA;AACN;AAEE;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;AAAJ;AACI;EACE,oCAAA;EACA,sBAAA;EACA,iBAAA;AACN;AACI;EACE,oCAAA;EACA,gBCrJc;EDsJd,mBAAA;EACA,iBAAA;AACN","sourcesContent":["@import '../../assets/variables';\n\n// List Row\n.v-divider {\n  display: inline-block;\n  vertical-align: top;\n  border-left: 1px solid darken($sidebarRowBg, 8%);\n  margin-left: 8px;\n  margin-right: 8px;\n  height: 21px;\n}\n\n/* .individual-view {\n\theight: calc(100vh - #{$headerHeight} - #{$footerHeight} - 80px);\n\t//margin-right: -17px;\n}\n */\n\na.list-row,\na.list-row * {\n  text-decoration: none;\n  cursor: pointer;\n}\n.list-view {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  font-size: $baseFontSize;\n  &.with-padding-right .list-row {\n    padding: 10px;\n  }\n  .list-row {\n    display: block;\n    padding: 5px;\n    //border-bottom: 1px solid darken($sidebarRowBg, 8%);\n    background: $sidebarRowBg;\n    color: $sidebarRowColor;\n    &.active,\n    &:hover {\n      background: $sidebarRowHoverBg;\n    }\n    .pull-right {\n      text-align: right;\n    }\n  }\n  a {\n    color: inherit;\n  }\n  .action-item {\n    font-size: $baseIconFontSize;\n    padding-left: 2px;\n    padding-right: 2px;\n    line-height: 24px;\n    .material-icons,\n    i {\n      color: inherit;\n      vertical-align: middle;\n    }\n    &.online {\n      color: $greenColor;\n    }\n    &.unknown {\n      color: $yellowColor;\n    }\n    &.stop {\n      color: $redColor;\n    }\n    &.offline {\n      color: $lightGrey;\n    }\n    &.away {\n      color: $yellowColor;\n    }\n    .circle {\n      margin-top: -0.2em;\n    }\n    .sub-menu {\n      min-width: 200px;\n    }\n    &.hovered:hover {\n      color: $themeColor;\n    }\n  }\n  .action-view:hover {\n    color: $skyColor;\n  }\n\n  .action-clear-list {\n    color: $redColor;\n    a {\n      cursor: pointer;\n    }\n  }\n\n  /* .action-ellipsis {\n\t\tvisibility: hidden;\n\t} */\n}\n.list-view-group {\n  @extend .list-view;\n\n  .list-row {\n    background: $sidebarHeadBg;\n  }\n}\n\n.group-view {\n  .list-view .list-row {\n    padding-left: 28px;\n  }\n  .list-view-group .list-row {\n    padding-left: 5px;\n    .unit-name {\n      font-weight: 600;\n      max-width: 120px;\n      min-width: 120px;\n    }\n  }\n}\n\n.action-view svg {\n  max-width: 18px;\n}\n.action-running svg {\n  max-width: 13px;\n}\n.action-accuracy svg {\n  max-width: 16px;\n}\n.action-connection svg {\n  max-width: 16px;\n}\n.action-battery svg {\n  max-width: 21;\n}\n.action-additional-menu svg {\n  max-width: 14px;\n}\n.action-clear-list svg {\n  max-width: 11px;\n}\n.action-ellipsis svg {\n  max-width: 6px;\n}\n\n.unit-name {\n  max-width: 155px;\n  min-width: 155px;\n  overflow: hidden;\n  white-space: nowrap;\n  display: inline-block;\n  text-overflow: ellipsis;\n  line-height: 18px;\n  margin-left: 10px;\n  vertical-align: middle;\n  img {\n    max-width: 20px;\n    height: auto;\n    vertical-align: middle;\n    margin-right: 5px;\n  }\n  &.unit-name-full {\n    min-width: inherit;\n    max-width: none;\n  }\n}\n\n.checkbox.full {\n  display: block;\n  width: auto;\n  .unit-name {\n    display: block;\n    min-width: inherit !important;\n    max-width: none !important;\n  }\n}\n\n.unit-details-box {\n  background: #fff;\n  padding: 10px;\n  border-bottom: 1px solid $borderColor;\n  .time-address-row {\n    margin-top: 0;\n    line-height: 1.7;\n  }\n  .statistics-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: $baseFontSize + 2;\n    margin-bottom: 10px;\n    td {\n      text-align: center;\n      border: 1px solid $borderColor;\n      vertical-align: middle;\n      padding: 10px;\n    }\n  }\n  .caption-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 10px;\n    td {\n      border: 1px solid $borderColor;\n      vertical-align: middle;\n      padding: 5px 10px;\n    }\n    th {\n      border: 1px solid $borderColor;\n      background: $sidebarBackground;\n      font-weight: normal;\n      padding: 5px 10px;\n    }\n  }\n}\n","@import 'functions';\n@import 'mixins';\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import 'bs_variables';\n\n// Layouts\n$sidebarWidth: 285px;\n$headerHeight: 46px;\n$footerHeight: 27px;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n// Header\n\n$borderColor: darken(white, 10%);\n$linkColor: #666;\n$hoverBg: darken($themeColor, 3%);\n$hoverColor: #fff;\n$hoverBorderColor: darken($themeColor, 10%);\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #fff;\n$blue: #012d55;\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #f3f3f3;\n$lightGrey: #999;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n$danger: $redColor;\n$warning: $yellowColor;\n$success: $greenColor;\n\n// Sidebar\n$sidebarBackground: #fff;\n$sidebarzIndex: 8;\n$sidebarHeadBg: #f9f9f9;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #eee;\n$sidebarRowColor: $darkGrey;\n\n// Footer\n\n$footerBackground: $themeColor;\n\n// typography\n$baseFontSize: 12px;\n$baseIconFontSize: 17px;\n\n$baseFontFamily: 'Open Sans', sans-serif;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
